import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Form } from 'react-bootstrap-v5';
import { useParams } from 'react-router-dom';
import "./Hobbies.css";

export default function Hobbies({ nextStep, prevStep, maxSteps, step }) {
  const { id } = useParams();
  const [hobbies, setHobbies] = useState([]);
  const [selectedHobbies, setSelectedHobbies] = useState([]);
  const [otherHobbies, setOtherHobbies] = useState([]);
  const [newHobby, setNewHobby] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        
        // Fetch all available hobbies
        const hobbiesResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/hobbies`, 
          { headers }
        );
        
        // Fetch user's selected hobbies
        const userHobbiesResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/user-hobbies/${id}`, 
          { headers }
        );

        setHobbies(hobbiesResponse.data);
        
        // Get just the IDs of selected hobbies
        const selectedIds = userHobbiesResponse.data
          .map(hobby => hobby.id)
          .filter(id => id !== 0); // Filter out the 'other' hobbies which have id=0
        
        // Get the 'other' hobbies
        const others = userHobbiesResponse.data
          .filter(hobby => hobby.id === 0)
          .map(hobby => hobby.hobby);
        
        setSelectedHobbies(selectedIds);
        setOtherHobbies(others);
      } catch (err) {
        setError('Error loading hobbies');
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  }, [id]);

  const saveHobbies = async (updatedStandardHobbies, updatedOtherHobbies) => {
    try {
      const token = localStorage.getItem('token');
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      await axios.post(
        `${process.env.REACT_APP_API_URL}/user-hobbies/${id}`,
        {
          standardHobbies: updatedStandardHobbies || selectedHobbies,
          otherHobbies: updatedOtherHobbies || otherHobbies
        },
        { headers }
      );
    } catch (err) {
      setError('Error saving hobbies');
      console.error('Error saving hobbies:', err);
    }
  };

  const toggleHobby = async (hobbyId) => {
    const newSelection = selectedHobbies.includes(hobbyId)
      ? selectedHobbies.filter(id => id !== hobbyId)
      : [...selectedHobbies, hobbyId];
    
    // Update state and save
    setSelectedHobbies(newSelection);
    await saveHobbies(newSelection, null);
  };

  const addOtherHobby = async () => {
    if (newHobby.trim()) {
      const updatedHobbies = [...otherHobbies, newHobby.trim()];
      setOtherHobbies(updatedHobbies);
      setNewHobby('');
      await saveHobbies(null, updatedHobbies);
    }
  };

  const removeOtherHobby = async (hobby) => {
    const updatedHobbies = otherHobbies.filter(h => h !== hobby);
    setOtherHobbies(updatedHobbies);
    await saveHobbies(null, updatedHobbies);
  };

  const handleNext = () => {
    nextStep();
  };

  return (


    <div className='container mt-5'>
      <h3>Select Your Hobbies or enter other hobbies</h3>
      {error && <div className="alert alert-danger">{error}</div>}
      
      <div className="other-hobbies mb-4">
        
        <div className="d-flex gap-2 mb-3">
          <Form.Control
            type="text"
            value={newHobby}
            onChange={(e) => setNewHobby(e.target.value)}
            placeholder="Enter other hobby"
          />
          <Button onClick={addOtherHobby}>Add</Button>
        </div>
        
        <div className="d-flex flex-wrap gap-2">
          {otherHobbies.map((hobby, index) => (
            <Button
              key={index}
              variant="success"
              className="d-flex align-items-center"
              onClick={() => removeOtherHobby(hobby)}
            >
              {hobby} <span className="ms-2">×</span>
            </Button>
          ))}
        </div>
      </div>

      <div className='hobbies-grid mb-4'>
        <style>
          {`
            .hobbies-grid {
              display: grid;
              grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
              gap: 10px;
              margin: 20px 0;
            }
            .hobby-button {
              width: 100%;
              margin: 5px;
            }
          `}
        </style>
        
        {hobbies.map((hobby) => (
          <Button
            key={hobby.id}
            variant={selectedHobbies.includes(hobby.id) ? 'success' : 'outline-primary'}
            className="hobby-button"
            onClick={() => toggleHobby(hobby.id)}
          >
            {hobby.hobby}
          </Button>
        ))}
      </div>

      

      <div className='footer'>
        <button className='navigate' disabled={step === 0} onClick={prevStep}>
          Prev
        </button>
        <button
          className='navigate'
          disabled={step === maxSteps}
          onClick={handleNext}
        >
          Next
        </button>
      </div>
    </div>
  );
}